/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 74733:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(60693);

/***/ }),

/***/ 76330:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var _require = __webpack_require__(89816),
  decode = _require.decode;
var _require2 = __webpack_require__(51343),
  Title = _require2.Title;
var Header = function Header(_ref) {
  var level = _ref.level,
    text = _ref.text;
  var decodedText = decode(text);
  var titleHeader = {
    1: /*#__PURE__*/_jsx(Title, {
      component: "h2",
      size: "xl",
      className: "subtitle"
    }, void 0, decodedText),
    2: /*#__PURE__*/_jsx(Title, {
      component: "h2",
      size: "xl",
      className: "subtitle"
    }, void 0, decodedText),
    3: /*#__PURE__*/_jsx(Title, {
      component: "h3",
      size: "l",
      className: "subtitle"
    }, void 0, decodedText),
    4: /*#__PURE__*/_jsx(Title, {
      component: "h4",
      size: "m",
      className: "subtitle"
    }, void 0, decodedText),
    5: /*#__PURE__*/_jsx(Title, {
      component: "h5",
      size: "s",
      className: "subtitle"
    }, void 0, decodedText),
    6: /*#__PURE__*/_jsx(Title, {
      component: "h6",
      size: "xs",
      className: "subtitle"
    }, void 0, decodedText)
  };
  return titleHeader[level];
};
Header.defaultProps = {
  level: 2,
  text: ''
};
module.exports = Header;

/***/ }),

/***/ 83233:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var ImageComponent = __webpack_require__(40986);
var _require = __webpack_require__(89816),
  decode = _require.decode;
var config = __webpack_require__(54869);
var Image = function Image(_ref) {
  var id = _ref.file.id,
    stretched = _ref.stretched,
    deviceType = _ref.deviceType,
    _ref$imgAlt = _ref.imgAlt,
    imgAlt = _ref$imgAlt === void 0 ? 'rich-text-image' : _ref$imgAlt,
    caption = _ref.caption;
  if (id) {
    return /*#__PURE__*/_jsx("div", {
      className: "image-container"
    }, void 0, /*#__PURE__*/_jsx(ImageComponent, {
      alt: imgAlt,
      image: id,
      customClass: "".concat(stretched ? 'full-width' : ''),
      imgconfig: config[deviceType].large
    }), caption && /*#__PURE__*/_jsx("p", {
      className: "caption"
    }, void 0, decode(caption)));
  }
  return null;
};
module.exports = Image;

/***/ }),

/***/ 15036:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Text = __webpack_require__(26520);
var Header = __webpack_require__(76330);
var List = __webpack_require__(79508);
var Image = __webpack_require__(83233);
module.exports = {
  Text: Text,
  Header: Header,
  List: List,
  Image: Image
};

/***/ }),

/***/ 79508:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var Unordered = __webpack_require__(18179);
var Ordered = __webpack_require__(21339);
var List = function List(_ref) {
  var items = _ref.items,
    style = _ref.style;
  var listsTypes = {
    unordered: /*#__PURE__*/_jsx(Unordered, {
      items: items
    }),
    ordered: /*#__PURE__*/_jsx(Ordered, {
      items: items
    })
  };
  return listsTypes[style];
};
List.defaultProps = {
  items: [],
  style: 'unordered'
};
module.exports = List;

/***/ }),

/***/ 21339:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
__webpack_require__(43133);
__webpack_require__(83790);
__webpack_require__(72341);
__webpack_require__(61000);
var Richtexthandler = __webpack_require__(95439);
var React = __webpack_require__(16689);
var Ordered = function Ordered(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_jsx("ol", {}, void 0, items.map(function (item, i) {
    return /*#__PURE__*/_jsx("li", {}, i, /*#__PURE__*/_jsx(Richtexthandler, {
      content: item
    }));
  }));
};
module.exports = Ordered;

/***/ }),

/***/ 26520:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
/* eslint-disable react/no-danger */
var React = __webpack_require__(16689);
var RichTextHandler = __webpack_require__(95439);
var Text = function Text(_ref) {
  var content = _ref.content,
    deeplinkData = _ref.deeplinkData;
  return /*#__PURE__*/_jsx("div", {
    className: "content-paragraph"
  }, void 0, /*#__PURE__*/_jsx(RichTextHandler, {
    content: content,
    deeplinkData: deeplinkData
  }));
};
Text.defaultProps = {
  content: '',
  deeplinkData: {}
};
module.exports = Text;

/***/ }),

/***/ 18179:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
__webpack_require__(43133);
__webpack_require__(83790);
__webpack_require__(72341);
__webpack_require__(61000);
var React = __webpack_require__(16689);
var RichTextHandler = __webpack_require__(95439);
var Unordered = function Unordered(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_jsx("ul", {}, void 0, items.map(function (item, i) {
    return /*#__PURE__*/_jsx("li", {}, i, /*#__PURE__*/_jsx(RichTextHandler, {
      content: item
    }));
  }));
};
module.exports = Unordered;

/***/ }),

/***/ 54869:
/***/ ((module) => {

module.exports = {
  mobile: {
    small: {
      size: 'B',
      prefix: 'D_NQ_NP_'
    },
    large: {
      size: 'B',
      prefix: 'D_NQ_NP_'
    }
  },
  desktop: {
    small: {
      size: 'OO',
      prefix: 'D_NQ_NP_'
    },
    large: {
      size: 'OO',
      prefix: 'D_NQ_NP_'
    }
  },
  tablet: {
    small: {
      size: 'G',
      prefix: 'D_NQ_NP_'
    },
    large: {
      size: 'G',
      prefix: 'D_NQ_NP_'
    }
  }
};

/***/ }),

/***/ 60693:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
var React = __webpack_require__(16689);
var _require = __webpack_require__(16689),
  useContext = _require.useContext;
var Variations = __webpack_require__(6996);
var _require2 = __webpack_require__(31901),
  LandingContext = _require2.LandingContext;
var schema = __webpack_require__(52274);
var RichText = function RichText(_ref) {
  var index = _ref.index,
    component = _ref.component;
  var _useContext = useContext(LandingContext),
    components = _useContext.landingData.components,
    deviceType = _useContext.landingConfig.deviceType;
  var json = component || components[index];
  return /*#__PURE__*/_jsx(Variations, {
    json: json,
    schema: schema,
    render: function render(_ref2) {
      var Variation = _ref2.Variation;
      return /*#__PURE__*/_reactJsxRuntime.jsx(Variation, _objectSpread(_objectSpread({}, json.data), {}, {
        deviceType: deviceType,
        styles: json.styles
      }));
    }
  });
};
RichText.defaultProps = {
  component: null
};
module.exports = RichText;

/***/ }),

/***/ 52274:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var normalVariation = __webpack_require__(39776);
module.exports = {
  normal: {
    component: normalVariation
  }
};

/***/ }),

/***/ 13199:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
__webpack_require__(43133);
__webpack_require__(83790);
__webpack_require__(72341);
__webpack_require__(61000);
var React = __webpack_require__(16689);
var _require = __webpack_require__(15036),
  Text = _require.Text,
  Header = _require.Header,
  List = _require.List,
  Image = _require.Image;
var RichTextItem = function RichTextItem(_ref) {
  var items = _ref.items,
    deviceType = _ref.deviceType;
  return items.map(function (item, key) {
    switch (item.type) {
      case 'header':
        return /*#__PURE__*/_reactJsxRuntime.jsx(Header, _objectSpread({}, item.data));
      case 'list':
        return /*#__PURE__*/_reactJsxRuntime.jsx(List, _objectSpread({}, item.data));
      case 'image':
        return /*#__PURE__*/_reactJsxRuntime.jsx(Image, _objectSpread(_objectSpread({}, item.data), {}, {
          deviceType: deviceType
        }));
      default:
        return /*#__PURE__*/_jsx(Text, {
          content: item.data.text,
          deeplinkData: item.data.deeplinkData
        }, key);
    }
  });
};
module.exports = RichTextItem;

/***/ }),

/***/ 39776:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var RichTextItem = __webpack_require__(13199);
var Normal = function Normal(_ref) {
  var items = _ref.items,
    _ref$fullwidth = _ref.fullwidth,
    fullwidth = _ref$fullwidth === void 0 ? false : _ref$fullwidth,
    deviceType = _ref.deviceType,
    styles = _ref.styles;
  return /*#__PURE__*/_jsx("section", {
    className: "hub__boxed-width container-rt",
    style: {
      backgroundColor: styles.bg_color || '#fff'
    }
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "content".concat(fullwidth ? ' fullwidth' : '')
  }, void 0, /*#__PURE__*/_jsx(RichTextItem, {
    items: items,
    deviceType: deviceType
  })));
};
module.exports = Normal;

/***/ }),

/***/ 51343:
/***/ ((module) => {

"use strict";
module.exports = require("@andes/typography");

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 40986:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/image");

/***/ }),

/***/ 95439:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/richtexthandler");

/***/ }),

/***/ 6996:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/variations");

/***/ }),

/***/ 43133:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.array.map.js");

/***/ }),

/***/ 83790:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.constructor.js");

/***/ }),

/***/ 72341:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.iterator.map.js");

/***/ }),

/***/ 61000:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ 89816:
/***/ ((module) => {

"use strict";
module.exports = require("html-entities");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(74733);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map